import React, { useState, useRef } from 'react';
import CustomHook from './CustomHook';

function Contacts() {
  const [listContacts] = useState([
    {
      title: 'Im active in Telegram',
      value: 'https://t.me/gevork_sarkisyan',
      icon: 'https://uxwing.com/wp-content/themes/uxwing/download/brands-and-social-media/telegram-white-icon.png',
    },
    {
      title: 'Email',
      value: 'zadroterkom@gmail.com',
      icon: 'https://mailmeteor.com/logos/assets/PNG/Gmail_Logo_White_512px.png',
    },
    {
      title: 'Linkedin',
      value: 'https://www.linkedin.com/in/gevork-sarkisyan-a1195328b/',
      icon: 'https://uxwing.com/wp-content/themes/uxwing/download/brands-and-social-media/linkedin-app-white-icon.png',
    },
    {
      title: 'GitHub',
      value: 'https://github.com/Gevork-Sarkisyan222',
      icon: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS7cmmOu4xUkNNZlk-qh4r47i9n6R1mLQD-3Q&s',
    },
  ]);
  const divs = useRef([]);
  const scrollTab = useRef();
  CustomHook(scrollTab, divs);

  return (
    <section className="contacts" ref={scrollTab}>
      <div className="title" ref={(el) => el && divs.current.push(el)}>
        This is my Contacts
      </div>
      <div className="des" ref={(el) => el && divs.current.push(el)}>
        {/* 20 */}
        Here you can contact with me call me or write me, but always know im active in telegram
      </div>
      <div className="list" ref={(el) => el && divs.current.push(el)}>
        {listContacts.map((value, key) => (
          <div className="item" key={key}>
            <h3 style={{ display: 'flex', gap: '5px', justifyContent: 'center' }}>
              <img width={25} height={25} src={value.icon} alt={`social icon of ${value.title}`} />
              <span>{value.title}</span>
            </h3>
            <div class="container">
              <span className="link-text">
                <a
                  target="_blank"
                  style={{ color: 'white', textDecoration: 'none' }}
                  href={
                    value.value === 'zadroterkom@gmail.com'
                      ? 'https://www.google.com/intl/ru/gmail/about/#inbox?compose=new'
                      : value.value
                  }>
                  {value.value}
                </a>
              </span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
export default Contacts;
